import type { JSONContent } from "@tiptap/core";
import Fetcher from "../Fetcher.ts";
import type { RFQAwardPurchaseOrder } from "./Awards.ts";

export type SendPOParams = {
    awardId: number;
    fileId: number;
    content?: string;
    contentJson: JSONContent;
    poNumber?: string;
    senderId?: number | null;
};

const f = Fetcher.default();

export default {
    sendPO: (params: SendPOParams) => {
        const { awardId, ...body } = params;
        return f.post<RFQAwardPurchaseOrder>(`/awards/${awardId}/purchase-orders`, { body });
    },
};
